import { createPlatformState } from '~/helpers/store'
import { EVENT_VIEWS } from '~/constants'

export const defaultFilters = {
  ...Object.entries(EVENT_VIEWS).reduce((acc, [eventView, { eventTypes }]) => ({
    ...acc,
    [eventView]: {
      types: eventTypes,
      categories: []
    },
    fromDate: null,
    toDate: null,
    houses: []
  }), {})
}

export default () => {
  const state = createPlatformState()

  return {
    ...state,
    meta: {
      ...state.meta,
      searches: {},
      inductionEventsFetching: false
    },
    filters: defaultFilters
  }
}
